import { apiFetch } from "./client";

// ---- Customer pay page (public, by quote token) ----

/** Add-ons, upgrade, FAQ and reviews for the pay page. Separate from the quote itself. */
export function getQuoteExtras(token) {
  return apiFetch(`/api/public/quotes/${token}/extras`);
}

/** Ask for extras. Only creates a request for the owner — it never changes the quote. */
export function requestExtras(token, { addonIds, upgrade, note }) {
  return apiFetch(`/api/public/quotes/${token}/requests`, {
    method: "POST",
    body: { addon_ids: addonIds, upgrade: Boolean(upgrade), note: note || undefined },
  });
}

// ---- Dashboard ----

export function getQuotePageSettings() {
  return apiFetch("/api/admin/quote-page");
}

export function saveQuotePageSettings(patch) {
  return apiFetch("/api/admin/quote-page", { method: "PUT", body: patch });
}

export function createAddon(addon) {
  return apiFetch("/api/admin/addons", { method: "POST", body: addon });
}

export function updateAddon(id, addon) {
  return apiFetch(`/api/admin/addons/${id}`, { method: "PUT", body: addon });
}

export function deleteAddon(id) {
  return apiFetch(`/api/admin/addons/${id}`, { method: "DELETE" });
}

export function listQuoteRequests() {
  return apiFetch("/api/admin/quote-requests");
}

export function resolveQuoteRequest(id, status) {
  return apiFetch(`/api/admin/quote-requests/${id}/resolve`, { method: "POST", body: { status } });
}
